
import axiosRequest from "@/api/axios-optimize"

// 获取定时器列表
export function getScheduleList(
  data = {},
  config = {
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/schedule/list`, { params: data, ...config })
}

// 新增定时任务
export function addSchedule(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.post(`/xiaobuAdmin/monitor/schedule/add`, data, config)
}

// 新增定时任务
export function updateSchedule(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.post(`/xiaobuAdmin/monitor/schedule/update`, data, config)
}

// 删除定时任务
export function deleteSchedule(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/monitor/schedule/delete`, { data, ...config })
}

// 启动定时任务
export function startSchedule(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.post(`/xiaobuAdmin/monitor/schedule/start`, data, config)
}

// 暂停定时任务
export function stopSchedule(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.post(`/xiaobuAdmin/monitor/schedule/stop`, data, config)
}

// 获取任务详情
export function getJobInfo(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.post(`/xiaobuAdmin/monitor/schedule/getJobInfo`, data, config)
}

// 判断是否存在
export function judgeExist(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/monitor/schedule/judgeExist`, data, config)
}

// 批量删除定时任务
export function batchDeleteSchedule(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/monitor/schedule/batchDelete`, { data, ...config })
}